import { render, staticRenderFns } from "./changpsd.vue?vue&type=template&id=55c0f012&scoped=true"
import script from "./changpsd.vue?vue&type=script&lang=js"
export * from "./changpsd.vue?vue&type=script&lang=js"
import style0 from "./changpsd.vue?vue&type=style&index=0&id=55c0f012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0f012",
  null
  
)

export default component.exports